const Page404 = () => {
    return ( 
        <div>
            <h2>Error 404</h2>
            Pagina no encontrada.
        </div>
     );
}
 
export default Page404;